import React, { useEffect, useRef } from 'react';
import { Chart as ChartJS, RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend } from 'chart.js';
import { Radar } from 'react-chartjs-2';

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

const processSurveyData = (surveyData) => {
  const labels = [];
  const data = [];
  console.log(surveyData)
  surveyData.forEach((response) => {
    const responseKeys = Object.keys(response);

    responseKeys.forEach((key) => {
      if (!labels.includes(key)) {
        labels.push(key);
      }
    });
  });

  labels.forEach((label) => {
    surveyData.forEach((response) => {
      const values = response[label];
      console.log(values);
      let count = 0;
      Object.keys(values).map(function(keyName, keyIndex) {
        console.log(values[keyName]);
        count += values[keyName];
      })
      data.push(count);
      console.log(data)
    });
  });
  
  return {
    labels: labels,
    data: data
  };
};

const ChartComponent = ({ data }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (chartRef && chartRef.current && chartRef.current.chartInstance) {
      chartRef.current.chartInstance.destroy(); // Destroy the previous chart instance
    }
  }, [data[0]]);

  if (!data[0] || data[0].length === 0) {
    return <div>No data available</div>;
  }

  const processedData = processSurveyData(data[0]);

  if (!processedData || !processedData.labels || processedData.labels.length === 0) {
    return <div>No valid data available for chart</div>;
  }

  const chartData = {
    labels: processedData.labels,
    datasets: [
      {
        label: 'Ist',
        data: processedData.data,
        backgroundColor: 'rgba(200,200,200,.6)',
        borderColor: 'rgba(200,200,200,1)',
        pointBackgroundColor: 'rgb(200,200,200)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgb(200, 200, 200)',
        borderWidth: 2
      }
      ,
      {
        label: 'Soll',
        data: [15, 10, 11, 13, 9],
        fill: true,
        backgroundColor: 'rgba(0, 255, 100, 0.2)',
        borderColor: 'rgb(0, 255, 100)',
        pointBackgroundColor: 'rgb(0, 255, 100)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgb(0, 255, 100)',
        borderWidth: 2
      }/*, {
        label: 'Buchhalrung',
        data: [4, 3, 5, 5, 4],
        fill: true,
        backgroundColor: 'rgba(54, 162, 235, 0.2)',
        borderColor: 'rgb(54, 162, 235)',
        pointBackgroundColor: 'rgb(54, 162, 235)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgb(54, 162, 235)'
      }
      */
    ]
  };

  const handleSaveTestData = async () => {
    console.log(data[1]);
    try {
      const response = await fetch('http://localhost:5001/survey', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify([chartData, data[1]]) // Hier die Daten übergeben
      });

      if (response.ok) {
        console.log('Test data saved successfully');
      } else {
        console.error('Failed to save test data');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };
  return (
    <div>
      {/*<button onClick={handleSaveTestData}>Submit Data</button> */}
      <Radar
        data={chartData}
        style={{
          maxWidth: 750,
          maxHeight: 400
        }}
        options={{
          aspectRatio: 1,
          responsive: true,
          scales: {
            r: {
              min: 0,
              max: 15,
              ticks: {
                stepSize: 5 // Adjust this based on your preference
              }
            }
          }
        }}
      />
    </div>
  );
};

export default ChartComponent;
